<div class="container" fxLayout="column" fxLayoutAlign="start start" fxFill>
  <div class="map" [class.loading]="loading" id="map-dashboard-{{id}}"></div>
  <sesio-loader *ngIf="loading" @loading class="loader"></sesio-loader>
  <mat-progress-bar *ngIf="loadingData" @loading color="accent" mode="indeterminate" [style.position]="'absolute'"
    [style.top.px]="4"></mat-progress-bar>
</div>
